module.exports = __webpack_public_path__ + "img/10.eb6a234f.png";